<script>
  import Map from "./Map.svelte";
  import { onMount } from "svelte";
  import html2canvas from "html2canvas";
  import { writable } from "svelte/store";
  import { jsPDF } from "jspdf";
  import Font from "./font.svelte";

  export let ready;
  let thug;

  let zoom = 7;
  let center = { lat: 48.856614, lng: 2.3522219 };

  let size = 32;

  let deleteMode = false;

  let map;

  let main;
  let currentId = -1;

  let chargement = false;

  let imgs = ["Table.svg", "Tente.svg", "Infirmerie.svg"];
  let occ = [0, 0, 0];

  let histo = writable([]);

  let currentCanvas;

  let defaultCanvas;

  class Stack {
    constructor() {
      this.stack = [];
    }

    push(el, id, x, y) {
      let info = {
        x,
        y,
        size,
        type: id,
      };
      if (id >= 0)
        histo.update((hist) => {
          hist.push(info);
          return hist;
        });
      this.stack.push({ canv: el, id, histo: deepCopy($histo) });
    }

    pop() {
      if (this.stack.length <= 1) {
        //alert("stack empty");
        return currentCanvas;
      } else {
        let temp = this.stack.pop();
        occ[temp.id]--;
        /*histo.update((hist) => {
          hist.pop();
          return hist;
        });*/
        histo.set(deepCopy(this.stack[this.stack.length - 1].histo));
        console.log($histo);
        return temp.canv;
        //return this.stack[this.stack.length - 1];
      }
    }
  }

  let stack = new Stack();

  const cropCanvas = (sourceCanvas, left, top, width, height) => {
    let destCanvas = document.createElement("canvas");
    destCanvas.width = width;
    destCanvas.height = height;
    destCanvas.getContext("2d").drawImage(
      sourceCanvas,
      left,
      top,
      width,
      height, // source rect with content to crop
      0,
      0,
      width,
      height
    ); // newCanvas, same size as source rect
    return destCanvas;
  };

  function resizeCanvas(originalCanvas, newWidth, newHeight) {
    // Create a new canvas with the desired dimensions
    const resizedCanvas = document.createElement("canvas");
    resizedCanvas.width = newWidth;
    resizedCanvas.height = newHeight;

    // Get the 2D context of the new canvas
    const context = resizedCanvas.getContext("2d");

    // Scale and draw the original canvas onto the new canvas
    context.drawImage(
      originalCanvas,
      0,
      0,
      originalCanvas.width,
      originalCanvas.height,
      0,
      0,
      newWidth,
      newHeight
    );
    return resizedCanvas;
  }

  function changeCursor(id) {
    main.style.cursor = "url(../" + id + ".cur), default;";
    currentId = id;
  }

  function copyCanvas(originalCanvas) {
    // Create a new canvas with the same dimensions as the original canvas
    const newCanvas = document.createElement("canvas");
    newCanvas.width = originalCanvas.width;
    newCanvas.height = originalCanvas.height;

    // Get the 2D context of the new canvas
    const context = newCanvas.getContext("2d");

    // Draw the original canvas onto the new canvas
    context.drawImage(originalCanvas, 0, 0);

    // Return the copied canvas
    return newCanvas;
  }

  function lol(event) {
    let config = {
      useCORS: true,
    };
    thug.style.display = "none";

    let parent = document.getElementById("map-container");
    let enfants = parent.children[1].children[0];
    console.log(enfants);
    html2canvas(enfants, config).then(function (canvas) {
      canvas = cropCanvas(
        canvas,
        canvas.width * 0.2,
        canvas.height * 0.05,
        canvas.width * 0.6,
        canvas.height * 0.9
      );
      canvas = resizeCanvas(
        canvas,
        enfants.offsetWidth * 0.6,
        enfants.offsetHeight * 0.9
      );
      map = event.detail.map;
      defaultCanvas = copyCanvas(canvas);
      ready = false;
      document.getElementById("new").appendChild(canvas);
      stack.push(copyCanvas(canvas), -1, 0, 0, $histo);
      currentCanvas = canvas;
    });
  }

  function changeCanvas(newCanvas) {
    document.getElementById("new").removeChild(currentCanvas);
    document.getElementById("new").appendChild(newCanvas);
  }

  let m = { x: 0, y: 0 };

  function handleMousemove(event) {
    m.x = event.clientX;
    m.y = event.clientY;
  }

  function isPointInsideCircle(mx, my, x, y, r) {
    const distance = Math.sqrt((mx - x) ** 2 + (my - y) ** 2);
    //console.log(distance);
    return distance <= r;
  }

  function dessine() {
    if (currentId >= 0) {
      let newC = copyCanvas(currentCanvas);
      let ctx = newC.getContext("2d");

      // Create an image element
      var img = new Image();
      img.onload = function () {
        let rect = document.getElementById("new").getBoundingClientRect();
        ctx.drawImage(
          img,
          m.x - rect.x - size / 2,
          m.y - rect.y - size / 2,
          size,
          size
        );
      };

      img.src = "../" + imgs[currentId];

      let rect = document.getElementById("new").getBoundingClientRect();
      //document.getElementById("new").appendChild(newC);
      changeCanvas(newC);
      currentCanvas = newC;
      stack.push(
        copyCanvas(newC),
        currentId,
        Math.round(m.x - rect.x - size / 2),
        Math.round(m.y - rect.y - size / 2)
      );

      occ[currentId]++;
      console.log(stack.stack);
    }
  }

  function deepCopy(arr) {
    let ne = [];
    arr.forEach((element) => {
      if (element != undefined) ne.push(element);
    });
    return ne;
  }

  function goback() {
    let newC = stack.pop();
    newC = copyCanvas(defaultCanvas);
    console.log("je pop la stack, len : " + stack.stack.length);
    if (true) {
      let ctx = newC.getContext("2d");

      for (let i = $histo.length - 1; i >= 0; i--) {
        if ($histo[i] != undefined) {
          drawCircle(ctx, i);
        }
      }

      changeCanvas(newC);
      currentCanvas = newC;
      //stack.push(copyCanvas(newC), -1, 0, 0);
    }
  }

  function handleKeyDown(event) {
    if (event.ctrlKey && (event.key === "z" || event.keyCode === 90)) {
      event.preventDefault();
      goback();
    }
  }

  function getIndexADelete() {
    let rect = document.getElementById("new").getBoundingClientRect();
    let x = m.x - rect.x;
    let y = m.y - rect.y;
    for (let i = $histo.length - 1; i >= 0; i--) {
      if ($histo[i] != undefined) {
        let pt = $histo[i];
        if (
          isPointInsideCircle(
            x - pt.size / 2,
            y - pt.size / 2,
            pt.x,
            pt.y,
            pt.size / 2
          )
        ) {
          return i;
        }
      }
    }
    return -1;
  }

  function createAndSaveFile(content, fileName) {
    const blob = new Blob([content], { type: "text/plain" });

    // Create a temporary link element
    const link = document.createElement("a");
    link.href = URL.createObjectURL(blob);
    link.download = fileName;

    // Programmatically trigger a click on the link element to initiate the file download
    link.click();

    // Cleanup
    URL.revokeObjectURL(link.href);
    link.remove();
  }

  function save() {
    let txt = "";
    txt += map.getZoom() + "\n";
    txt += map.getCenter().lat() + "\n";
    txt += map.getCenter().lng() + "\n";
    let mapBoxRect = document.getElementById("new").getBoundingClientRect();
    txt += mapBoxRect.width + "\n";
    txt += mapBoxRect.height + "\n";
    $histo.forEach((pt) => {
      txt += pt.x + "/" + pt.y + "/" + pt.size + "/" + pt.type + "\n";
    });
    createAndSaveFile(txt, "Implantation.imp");
  }

  function cleanDeMort() {
    histo.update((hist) => {
      let ne = [];
      hist.forEach((el) => {
        if (el != undefined) ne.push(el);
      });
      return ne;
    });
    stack.stack[stack.stack.length - 1].histo = deepCopy($histo);
  }

  function drawCircle(context, i) {
    var img = new Image();
    img.onload = function () {
      context.drawImage(
        img,
        $histo[i].x,
        $histo[i].y,
        $histo[i].size,
        $histo[i].size
      );
    };

    img.src = "../" + imgs[$histo[i].type];
  }

  function deleteEl(x, y) {
    let pb = getIndexADelete();
    if (pb >= 0) {
      console.log("Je dois retirer le " + pb);
      let rect = document.getElementById("new").getBoundingClientRect();
      x = m.x - rect.x;
      y = m.y - rect.y;

      let newC = copyCanvas(defaultCanvas);
      let ctx = newC.getContext("2d");

      for (let i = $histo.length - 1; i >= 0; i--) {
        if ($histo[i] != undefined && i != pb) {
          drawCircle(ctx, i);
          console.log("je dessine le " + i);
        }
      }
      $histo[pb] = undefined;

      changeCanvas(newC);
      currentCanvas = newC;

      stack.push(copyCanvas(newC), -1, 0, 0);
      console.log("Stack : ");
      console.log(stack.stack);
    }
  }

  function addImgToDoc(doc, path, x, y) {
    var img = new Image();
    path = path.slice(0, -4);
    path += ".png";
    img.src = "../" + path;
    doc.addImage(img, "png", x, y, 32, 32);
  }

  function getNumberOfUsed() {
    cleanDeMort();
    let o = {};
    $histo.forEach((el) => {
      o[el.type] = true;
    });
    console.log(o);
    return o;
  }

  function exportImg() {
    let used = Object.keys(getNumberOfUsed());
    console.log(used);
    let w = currentCanvas.width;
    let h = currentCanvas.height;
    let nbVertical = Math.floor(h / 60);
    let nbHorizontal = used.length / nbVertical + 1;
    var doc = new jsPDF({
      orientation: "landscape",
      unit: "px",
      format: [w + 200 * nbHorizontal, h],
    });
    //let doc = new jsPDF("l", "px", [currentCanvas.width, currentCanvas.height]);
    //FONT
    doc.setFont("CaveatBrush-Regular", "normal");
    doc.setFontSize(28);
    //END FONT

    let x = w + 15;
    let y = 30;

    var imgData = currentCanvas.toDataURL("image/png");
    doc.addImage(imgData, "PNG", 0, 0, w, h);

    let current = 0;
    for (let i = 0; i < used.length; i++) {
      console.log(current + " " + nbVertical);
      if (current == nbVertical) {
        current = 0;
        x += 200;
        y = 30;
      }
      addImgToDoc(doc, imgs[used[i]], x, y);
      x += 40;
      y += 20;
      doc.text(imgs[used[i]].slice(0, -4), x, y);
      x -= 40;
      y += 40;
      current += 1;
    }

    doc.save("Implantation.pdf");
  }

  let load = true;

  function handleFileSelect(event) {
    chargement = true;
    setTimeout(() => {
      lol(event);
    }, 1000);

    setTimeout(() => {
      let rect = currentCanvas.getBoundingClientRect();
      let lines = event.detail.fileContent.split("\n");
      let witdh = parseInt(lines[3]);
      let height = parseInt(lines[4]);
      let newWidth = rect.width;
      let newHeight = rect.height;
      let ctx = currentCanvas.getContext("2d");
      for (let i = 5; i < lines.length - 1; i++) {
        let ptx = lines[i].split("/");
        let x = (parseFloat(ptx[0]) / witdh) * newWidth;
        let y = (parseFloat(ptx[1]) / height) * newHeight;
        let s = (parseInt(ptx[2]) / witdh) * newWidth;
        let t = parseInt(ptx[3]);
        occ[t]++;

        $histo.push({ x, y, size: s, type: t });
        //Draw

        let img = new Image();
        img.src = "../" + imgs[t];
        img.onload = function () {
          ctx.drawImage(img, x, y, s, s);
        };
      }
      chargement = false;
    }, 2000);
  }

  document.addEventListener("keydown", handleKeyDown);
</script>

<svelte:head>
  <script
    defer
    async
    src="https://maps.googleapis.com/maps/api/js?key=AIzaSyBGup7Igz2NTnG4wlrXy6Chp1RDn7eLM-o&callback=initMap"
  >
  </script>
</svelte:head>

<Font />
<main id="main" bind:this={main}>
  <div id="map-container">
    {#if ready}
      <div class="area" bind:this={thug} />
      {#if load}
        <Map {zoom} {center} on:capture={lol} on:loadMap={handleFileSelect} />
      {/if}
    {/if}
  </div>

  <!-- svelte-ignore a11y-click-events-have-key-events -->
  <div
    id="new"
    on:mousemove={handleMousemove}
    on:click={() => (deleteMode ? deleteEl(m.x, m.y) : dessine())}
  />
  {#if !ready}
    <div class="legend">
      {#each imgs as im, i}
        <!-- svelte-ignore a11y-click-events-have-key-events -->
        <div
          style="margin:1vh;display: flex; align-items:center;cursor:pointer;"
          on:click={() => changeCursor(i)}
        >
          <img width="64" height="64" src={"../" + imgs[i]} alt={im} />
          <span>{im.slice(0, -4)}</span>
        </div>
      {/each}
    </div>
    <div style="border:1px solid black;display: flex; flex-direction:column;">
      <button
        on:click={() => {
          deleteMode = !deleteMode;
          cleanDeMort();
        }}>Delete mode : {deleteMode ? "OUI" : "NON"}</button
      >
      <button on:click={goback}>Annuler</button>
      <button on:click={exportImg}>Export</button>
      <button on:click={save}>Save</button>
      <input type="range" min="8" max="128" bind:value={size} />
      <span>Taille : {size}</span>
      <img
        src={currentId >= 0 ? "../" + imgs[currentId] : "../" + imgs[0]}
        width={size}
        height={size}
        alt="lol"
      />
    </div>
  {/if}
</main>

{#if chargement}
  <div
    style="z-index:1000000;display: flex;align-items:center;justify-content:center;position:absolute;top:0;left:0;background-color:#FDD;width:100vw;height:100vh"
  >
    Chargement...
  </div>
{/if}

<style>
  :global(body) {
    padding: 0;
  }
  main {
    justify-content: center;
    display: flex;
    align-items: center;
    width: 100vw;
    height: 100vh;
  }

  #new {
    width: fit-content;
    height: fit-content;
    max-width: 80vw;
    max-height: 70vh;
  }

  .area {
    display: none;
    position: absolute;
    background-color: rgba(255, 0, 0, 0.3);
    border: 1px solid red;
    left: 15%;
    top: 18%;
    width: 50%;
    height: 65%;
    pointer-events: none;
    z-index: 2;
  }

  .legend {
    margin-left: 5vw;
  }
</style>
